module.exports = __webpack_public_path__ + "img/knsu_main0.4c54183b.jpg";